import LeadsTable from './LeadsTable';
import { LeadsTableType } from './utils';

export default LeadsTable;
export {
  LeadsTableType,
};
